module.exports = __webpack_public_path__ + "static/media/block_quote.6ac516ed.svg";